(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mkMarquee = document.querySelector('.mk-marquee');
    if (!mkMarquee) return;

    const isMobile = window.innerWidth < 768;
    const mobileBehavior = mkMarquee.getAttribute('data-mk-marquee-mobile');
    if (mobileBehavior === 'off-mobile' && isMobile) {
      mkMarquee.remove();
      return;
    }

    const mkMarqueeWrapper = mkMarquee.querySelector('.mk-marquee__wrapper');
    const mkMarqueeContent = mkMarquee.querySelector('.mk-marquee__content');

    if (!mkMarqueeContent || !mkMarqueeContent.textContent.trim() || mkMarqueeContent.children.length === 0) {
      mkMarquee.remove();
      return;
    }

    function getAttr(attr, defaultValue) {
      const value = mkMarquee.getAttribute(attr);
      return value ? value.trim() : defaultValue;
    }

    function getNumberAttr(attr, defaultValue) {
      const value = parseInt(getAttr(attr, defaultValue));
      return isNaN(value) ? defaultValue : value;
    }

    const mkScrollSpeed = getNumberAttr('data-mk-marquee-speed', 200);
    const mkMarqueeBgColor = getAttr('data-mk-marquee-bg-color', '#000');
    const mkMarqueeTextColor = getAttr('data-mk-marquee-text-color', '#FFF');
    const mkMarqueeFontSize = getNumberAttr('data-mk-marquee-font-size', 16) + 'px';
    const mkMarqueeHeight = getNumberAttr('data-mk-marquee-height', 50) + 'px';
    const mkMarqueeHoverPause = getAttr('data-mk-marquee-hover-pause', 'false') === 'true';
    const mkMarqueePosition = getAttr('data-mk-marquee-position', 'bottom');

    mkMarquee.style.setProperty('--mk-marquee-bg-color', mkMarqueeBgColor);
    mkMarquee.style.setProperty('--mk-marquee-text-color', mkMarqueeTextColor);
    mkMarquee.style.setProperty('--mk-marquee-font-size', mkMarqueeFontSize);
    mkMarquee.style.setProperty('--mk-marquee-height', mkMarqueeHeight);

    const extraPadding = 10;
    if (mkMarqueePosition === 'top') {
      mkMarquee.style.top = '0';
      document.body.style.paddingTop = parseInt(mkMarqueeHeight) + extraPadding + 'px';
    } else {
      mkMarquee.style.bottom = '0';
      document.body.style.paddingBottom = parseInt(mkMarqueeHeight) + extraPadding + 'px';
    }

    if (mkMarqueeHoverPause) {
      mkMarquee.classList.add('mk-marquee--pause-on-hover');
    }

    function extendContent() {
      const contentWidth = mkMarqueeContent.scrollWidth;
      const wrapperWidth = mkMarquee.offsetWidth;

      const items = mkMarqueeContent.querySelectorAll('li');

      if (items.length === 1) {
        const li = items[0];
        const originalText = li.textContent.trim();
        let repeatCount = 2;
        const parts = [originalText];

        while (li.scrollWidth < mkMarquee.offsetWidth && repeatCount < 20) {
          parts.push(originalText);
          repeatCount++;
        }

        li.textContent = '\u00A0' + parts.join(' \u00A0') + '\u00A0';
      } else {
        let repeatCount = 1;
        const originalHTML = mkMarqueeContent.innerHTML;

        while (mkMarqueeContent.scrollWidth < wrapperWidth * 2 && repeatCount < 20) {
          mkMarqueeContent.innerHTML += originalHTML;
          repeatCount++;
        }
      }
    }

    extendContent();

    const mkDuplicateContent = mkMarqueeContent.cloneNode(true);
    mkDuplicateContent.setAttribute('aria-hidden', 'true');
    mkMarqueeWrapper.appendChild(mkDuplicateContent);

    function calculateSpeed() {
      const contentWidth = mkMarqueeContent.scrollWidth;
      const totalDistance = contentWidth * 2;
      const animationDuration = totalDistance / mkScrollSpeed;
      mkMarquee.style.setProperty('--mk-marquee-speed', `${animationDuration}s`);
    }

    calculateSpeed();

    new MutationObserver(() => {
      extendContent();
      calculateSpeed();
    }).observe(mkMarqueeContent, {
      childList: true,
      subtree: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mkMarquee = document.querySelector('.bb');
    if (!mkMarquee) return;

    const isMobile = window.innerWidth < 768;
    const mobileBehavior = mkMarquee.getAttribute('data-bb-mobile');
    if (mobileBehavior === 'off-mobile' && isMobile) {
      mkMarquee.remove();
      return;
    }

    const mkMarqueeWrapper = mkMarquee.querySelector('.bb__wrapper');
    const mkMarqueeContent = mkMarquee.querySelector('.bb__content');

    if (!mkMarqueeContent || !mkMarqueeContent.textContent.trim() || mkMarqueeContent.children.length === 0) {
      mkMarquee.remove();
      return;
    }

    function getAttr(attr, defaultValue) {
      const value = mkMarquee.getAttribute(attr);
      return value ? value.trim() : defaultValue;
    }

    function getNumberAttr(attr, defaultValue) {
      const value = parseInt(getAttr(attr, defaultValue));
      return isNaN(value) ? defaultValue : value;
    }

    const mkScrollSpeed = getNumberAttr('data-bb-speed', 200);
    const mkMarqueeBgColor = getAttr('data-bb-bg-color', '#000');
    const mkMarqueeTextColor = getAttr('data-bb-text-color', '#FFF');
    const mkMarqueeFontSize = getNumberAttr('data-bb-font-size', 16) + 'px';
    const mkMarqueeHeight = getNumberAttr('data-bb-height', 50) + 'px';
    const mkMarqueeHoverPause = getAttr('data-bb-hover-pause', 'false') === 'true';
    const mkMarqueePosition = getAttr('data-bb-position', 'bottom');

    mkMarquee.style.setProperty('--bb-bg-color', mkMarqueeBgColor);
    mkMarquee.style.setProperty('--bb-text-color', mkMarqueeTextColor);
    mkMarquee.style.setProperty('--bb-font-size', mkMarqueeFontSize);
    mkMarquee.style.setProperty('--bb-height', mkMarqueeHeight);

    const extraPadding = 10;
    if (mkMarqueePosition === 'top') {
      mkMarquee.style.top = '0';
      document.body.style.paddingTop = parseInt(mkMarqueeHeight) + extraPadding + 'px';
    } else {
      mkMarquee.style.bottom = '0';
      document.body.style.paddingBottom = parseInt(mkMarqueeHeight) + extraPadding + 'px';
    }

    if (mkMarqueeHoverPause) {
      mkMarquee.classList.add('bb--pause-on-hover');
    }

    function extendContent() {
      const contentWidth = mkMarqueeContent.scrollWidth;
      const wrapperWidth = mkMarquee.offsetWidth;

      const items = mkMarqueeContent.querySelectorAll('li');

      if (items.length === 1) {
        const li = items[0];
        const originalText = li.textContent.trim();
        let repeatCount = 2;
        const parts = [originalText];

        while (li.scrollWidth < mkMarquee.offsetWidth && repeatCount < 20) {
          parts.push(originalText);
          repeatCount++;
        }

        li.textContent = '\u00A0' + parts.join(' \u00A0') + '\u00A0';
      } else {
        let repeatCount = 1;
        const originalHTML = mkMarqueeContent.innerHTML;

        while (mkMarqueeContent.scrollWidth < wrapperWidth * 2 && repeatCount < 20) {
          mkMarqueeContent.innerHTML += originalHTML;
          repeatCount++;
        }
      }
    }

    extendContent();

    const mkDuplicateContent = mkMarqueeContent.cloneNode(true);
    mkDuplicateContent.setAttribute('aria-hidden', 'true');
    mkMarqueeWrapper.appendChild(mkDuplicateContent);

    function calculateSpeed() {
      const contentWidth = mkMarqueeContent.scrollWidth;
      const totalDistance = contentWidth * 2;
      const animationDuration = totalDistance / mkScrollSpeed;
      mkMarquee.style.setProperty('--bb-speed', `${animationDuration}s`);
    }

    calculateSpeed();

    new MutationObserver(() => {
      extendContent();
      calculateSpeed();
    }).observe(mkMarqueeContent, {
      childList: true,
      subtree: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"]) return;
  try {
    
  const container = document.querySelector('.carousel-outer');
  const track = document.querySelector('.track');
  const btnNext = document.querySelector('.btn-next');
  const btnPrev = document.querySelector('.btn-prev');
  let items = Array.from(document.querySelectorAll('.item'));
  const getSlidesToShow = () => {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  };
  let position = 0;
  let slidesToShow = getSlidesToShow();
  let slidesToMove = 1;
  let itemWidth = container.clientWidth / slidesToShow;
  let movePosition = slidesToMove * itemWidth;

  // Clone slides for infinite effect
  const cloneSlides = () => {
    items.forEach((item) => {
      const cloneStart = item.cloneNode(true);
      const cloneEnd = item.cloneNode(true);
      track.appendChild(cloneEnd);
      track.insertBefore(cloneStart, track.firstChild);
    });
    items = Array.from(document.querySelectorAll('.item'));
  };

  const setWidths = () => {
    slidesToShow = getSlidesToShow();
    itemWidth = container.clientWidth / slidesToShow;
    movePosition = slidesToMove * itemWidth;
    items.forEach((item) => {
      item.style.minWidth = `${itemWidth}px`;
      item.style.maxWidth = `${itemWidth}px`;
    });
    position = (-itemWidth * items.length) / 3;
    setPosition();
  };

  const setPosition = () => {
    track.style.transform = `translateX(${position}px)`;
  };

  const nextSlide = () => {
    position -= movePosition;
    setPosition();
    if (Math.abs(position) >= itemWidth * (items.length - slidesToShow)) {
      setTimeout(() => {
        position = (-itemWidth * items.length) / 3;
        track.style.transition = 'none';
        setPosition();
        requestAnimationFrame(() => {
          track.style.transition = 'transform 0.3s ease';
        });
      }, 300);
    }
  };

  const prevSlide = () => {
    position += movePosition;
    setPosition();
    if (position > 0) {
      setTimeout(() => {
        position = (-itemWidth * items.length) / 3;
        track.style.transition = 'none';
        setPosition();
        requestAnimationFrame(() => {
          track.style.transition = 'transform 0.3s ease';
        });
      }, 300);
    }
  };

  btnNext.addEventListener('click', nextSlide);
  btnPrev.addEventListener('click', prevSlide);

  window.addEventListener('resize', () => {
    setWidths();
    setEqualHeights();
  });
  const setEqualHeights = () => {
    items.forEach((item) => (item.style.height = 'auto'));

    const maxHeight = Math.max(...items.map((item) => item.offsetHeight));

    items.forEach((item) => (item.style.height = `${maxHeight}px`));
  };

  // Init
  cloneSlides();
  setWidths();
  setEqualHeights();

  let autoplayInterval;
  let isDragging = false;
  let startX = 0;
  let currentX = 0;
  let prevPosition = 0;

  const startAutoplay = () => {
    stopAutoplay();
    autoplayInterval = setInterval(() => {
      nextSlide();
    }, 3000); // 3 seconds
  };
  const stopAutoplay = () => {
    if (autoplayInterval) clearInterval(autoplayInterval);
  };

  // Drag functionality
  const onDragStart = (e) => {
    isDragging = true;
    startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    prevPosition = position;
    stopAutoplay();
    track.style.cursor = 'grabbing';
  };
  const onDragMove = (e) => {
    if (!isDragging) return;
    currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const dx = currentX - startX;
    position = prevPosition + dx;
    setPosition();
  };
  const onDragEnd = (e) => {
    if (!isDragging) return;
    isDragging = false;
    const dx = (e.type.includes('touch') ? e.changedTouches[0].clientX : e.clientX) - startX;
    if (Math.abs(dx) > itemWidth / 4) {
      if (dx < 0) nextSlide();
      else prevSlide();
    } else {
      setPosition();
    }
    startAutoplay();
    track.style.cursor = '';
  };

  track.addEventListener('mousedown', onDragStart);
  track.addEventListener('touchstart', onDragStart, { passive: true });
  window.addEventListener('mousemove', onDragMove);
  window.addEventListener('touchmove', onDragMove, { passive: false });
  window.addEventListener('mouseup', onDragEnd);
  window.addEventListener('touchend', onDragEnd);

  // Pause autoplay on hover
  container.addEventListener('mouseenter', stopAutoplay);
  container.addEventListener('mouseleave', startAutoplay);

  // After your existing init code:
  startAutoplay();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-titles li');
    const tabContents = document.querySelectorAll('.tab');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        tabs.forEach((t) => t.classList.remove('active'));
        tabContents.forEach((tc) => tc.classList.remove('active'));

        this.classList.add('active');
        const activeTab = this.getAttribute('data-tab');
        const activeContent = document.getElementById(activeTab);
        activeContent.classList.add('active');

        if (window.QuickAdd && typeof window.QuickAdd.init === 'function') {
          window.QuickAdd.init();
        }

        document.dispatchEvent(new CustomEvent('shopify:section:load'));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-titles li');
    const tabContents = document.querySelectorAll('.tab');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        tabs.forEach((t) => t.classList.remove('active'));
        tabContents.forEach((tc) => tc.classList.remove('active'));

        this.classList.add('active');
        const activeTab = this.getAttribute('data-tab');
        document.getElementById(activeTab).classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
